export default "__VITE_PUBLIC_ASSET__4bb7e17c__"